import { createSlice } from '@reduxjs/toolkit';

const initialState: ImportExportSidePanelStatus = {
    isOpen: false
};

const importExportSidePanel = createSlice({
    name: 'importExportSidePanel',
    initialState,
    reducers: {
        openSidePanel(state) {
            state.isOpen = true;
        },
        closeSidePanel(state) {
            state.isOpen = false;
        }
    }
});

export const { openSidePanel, closeSidePanel } = importExportSidePanel.actions;
export default importExportSidePanel.reducer;
